(() => {
  const STORAGE_KEY = "smmrskin_returning";

  function initAnnouncementLogic() {
    const component = document.querySelector("slideshow-component.announcement-bar");
    if (!component) return;

    const slider = component.querySelector(".slider");
    const slides = component.querySelectorAll(".slideshow__slide[data-announcement-type]");
    if (!slider || slides.length === 0) return;

    const isReturning = localStorage.getItem(STORAGE_KEY) === "1";
    localStorage.setItem(STORAGE_KEY, "1");

    // Show/hide slides
    slides.forEach((slide) => {
      const type = slide.dataset.announcementType;
      const shouldShow = isReturning ? (type === "trust" || type === "sale") : (type === "trust");
      slide.hidden = !shouldShow;
      slide.setAttribute("aria-hidden", shouldShow ? "false" : "true");
      if (!shouldShow) slide.setAttribute("tabindex", "-1");
    });

    // Autoplay: returning = rotate, first-time = no rotate
    slider.dataset.autoplay = isReturning ? "true" : "false";

    // Force Dawn slideshow to apply autoplay state
    // (Different themes expose different methods - we try the common ones safely)
    if (isReturning) {
      if (typeof component.play === "function") component.play();
      if (typeof component.startAutoplay === "function") component.startAutoplay();
    } else {
      if (typeof component.pause === "function") component.pause();
      if (typeof component.stopAutoplay === "function") component.stopAutoplay();
    }

    // Nudge layout listeners (Dawn sliders often recalc on resize)
    window.dispatchEvent(new Event("resize"));
  }

  document.addEventListener("DOMContentLoaded", initAnnouncementLogic);
})();
